/**
 * Per-page hydration entry.
 *
 * One entry per route so each page downloads only its own component code.
 * A single shared bundle meant the home page shipped all 8 pages' components
 * (~147 KB of it unused). Common code (React, Layout, Nav, Footer) is hoisted
 * into a shared chunk by Bun's code splitting, so it is still cached across
 * navigations.
 */
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Article2BOffset } from '@/pages/Article2BOffset.tsx';
import '@/styles/global.css';

const container = document.getElementById('root');
if (container) {
  hydrateRoot(
    container,
    <StrictMode>
      <Article2BOffset />
    </StrictMode>,
  );
}
